import React from 'react';
export const ValueStackTable = () => {
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-241">
      <div className="max-w-[780px] mx-auto" data-id="element-242">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-243">
          Everything You Get Today
        </h2>

        <div className="max-w-[680px] mx-auto border border-accent rounded-[16px] overflow-hidden" data-id="element-244">
          <div className="overflow-x-auto" data-id="element-245">
            <table className="w-full min-w-[300px] border-collapse" data-id="element-246">
              <thead data-id="element-247">
                <tr data-id="element-248">
                  <th className="bg-light text-primary font-lato font-bold text-[15px] text-left p-4 md:px-5 border-b border-accent" data-id="element-249">
                    Product
                  </th>
                  <th className="bg-light text-primary font-lato font-bold text-[15px] text-right p-4 md:px-5 border-b border-accent w-[120px]" data-id="element-250">
                    Real Value
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-251">
                <tr data-id="element-252">
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 border-b border-accent" data-id="element-253">
                    Main Ebook: The Hormonal Balance Code
                  </td>
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 text-right border-b border-accent" data-id="element-254">
                    $37
                  </td>
                </tr>
                <tr data-id="element-255">
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 border-b border-accent" data-id="element-256">
                    Bonus 1: Hormones in the Kitchen (30 complete recipes)
                  </td>
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 text-right border-b border-accent" data-id="element-257">
                    $27
                  </td>
                </tr>
                <tr data-id="element-258">
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 border-b border-accent" data-id="element-259">
                    Bonus 2: The Bible of Smart Supplementation
                  </td>
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 text-right border-b border-accent" data-id="element-260">
                    $37
                  </td>
                </tr>
                <tr data-id="element-261">
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 border-b border-accent" data-id="element-262">
                    Bonus 3: My Transformation Journal
                  </td>
                  <td className="font-lato text-[15px] text-body p-4 md:px-5 text-right border-b border-accent" data-id="element-263">
                    $17
                  </td>
                </tr>
                <tr data-id="element-264">
                  <td className="bg-accent font-lato font-bold text-[16px] text-body p-4 md:px-5 border-b border-accent" data-id="element-265">
                    TOTAL BUNDLE VALUE
                  </td>
                  <td className="bg-accent font-lato font-bold text-[16px] text-body p-4 md:px-5 text-right border-b border-accent line-through" data-id="element-266">
                    $118
                  </td>
                </tr>
                <tr data-id="element-267">
                  <td className="bg-medium font-lato font-bold text-[20px] md:text-[24px] text-white p-4 md:px-5" data-id="element-268">
                    YOUR PRICE TODAY
                  </td>
                  <td className="bg-medium font-lato font-bold text-[20px] md:text-[24px] text-white p-4 md:px-5 text-right" data-id="element-269">
                    $27
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
};